<template>
  <TaskStatus readonly class="table-data-status" v-bind="$attrs" />
</template>

<script>
import TaskStatus from '@/components/Task/Status/Default'

export default {
  components: {
    TaskStatus,
  },
}
</script>

<style lang="scss">
.table-data-status {
}
</style>
